import { connect } from 'react-redux'
import { createWidget } from 'pages/widgets/form-actions/create/actions'
import Form from 'pages/widgets/form'
import { getInitialSpeedThreadValues } from './initialValues'

const mapDispatch = {
  onSubmit: createWidget
}

const date = new Date().valueOf()

export default connect(
  () => ({ initialValues: getInitialSpeedThreadValues(date) }),
  mapDispatch
)(Form)



// WEBPACK FOOTER //
// ./src/pages/widgets/twitter_speed_thread/create/container/index.js